import { on, reducer } from "ts-action";
import {
  setSelectedBranchesMap,
  ISelectedBranchesMap,
} from "../actions/pickupBranchesActions";

const initialState: ISelectedBranchesMap = {
  pickup_branch_ids: {},
  delivery_branch_ids: {},
  drive_thru_branch_ids: {},
};

export const selectedBranchesMapReducer = reducer<ISelectedBranchesMap>(
  [on(setSelectedBranchesMap, (_, { payload }) => payload)],
  initialState
);
